export default __webpack_public_path__ + "static/journal-article-desktop-8174fa1bd29cd42bec05e44850c3b31d.png";